import React from 'react';
import { Section } from './ui/Section';
export function TransformationSection() {
  return <Section className="bg-navy-800" dark={true} data-id="element-189">
      <div className="max-w-3xl mx-auto text-center space-y-12" data-id="element-190">
        <h2 className="text-4xl md:text-5xl font-serif text-cream-50" data-id="element-191">
          Imagine this instead
        </h2>

        <div className="space-y-8 text-xl md:text-2xl font-light leading-relaxed text-cream-100/90" data-id="element-192">
          <p data-id="element-193">
            You get into bed… and your body actually{' '}
            <span className="italic text-gold-400" data-id="element-194">lets go.</span>
          </p>
          <p data-id="element-195">You still have thoughts—but they don't hook you.</p>
          <div className="py-8 border-y border-navy-700 space-y-4" data-id="element-196">
            <p data-id="element-197">If you wake up at 3am, you don't panic.</p>
            <p className="font-medium text-cream-50" data-id="element-198">You run a script.</p>
            <p className="font-medium text-cream-50" data-id="element-199">You settle.</p>
            <p className="font-medium text-cream-50" data-id="element-200">You drift back.</p>
          </div>
          <p data-id="element-201">
            And in the morning, you feel steadier—not because life is perfect,
            but because you finally rested.
          </p>
        </div>
      </div>
    </Section>;
}